import axios from "axios";

export const mainApi = axios.create({
  baseURL: process.env.REACT_APP_URL_CUSTOMERS,
  ContentType: 'application/json; charset=utf-8'
})
